module.exports = __webpack_public_path__ + "img/خلاق.d8a036cc.png";